export default __webpack_public_path__ + "static/media/hero_image_2.0f8733b1.png";